// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NewCustomSkillModal.module.css */

.NewCustomSkillModal_spin__Iv2Cb { animation: NewCustomSkillModal_spin__Iv2Cb 1s linear infinite; }
@keyframes NewCustomSkillModal_spin__Iv2Cb { to { transform: rotate(360deg); } }

.NewCustomSkillModal_overlay__iQRhZ {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
}

.NewCustomSkillModal_modal__R4h8S {
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 680px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.NewCustomSkillModal_header__lru86 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.NewCustomSkillModal_title__66TRW {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #111827;
}

.NewCustomSkillModal_closeBtn__3Kevh {
  background: none;
  border: none;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.NewCustomSkillModal_closeBtn__3Kevh:hover:not(:disabled) {
  background: #f3f4f6;
  color: #111827;
}
.NewCustomSkillModal_closeBtn__3Kevh:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.NewCustomSkillModal_body__h-GZH {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.NewCustomSkillModal_intro__ekX0W {
  margin: 0 0 16px 0;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.5;
}

.NewCustomSkillModal_section__6IU6f {
  margin-bottom: 22px;
  padding-bottom: 18px;
  border-bottom: 1px dashed #e5e7eb;
}
.NewCustomSkillModal_section__6IU6f:last-of-type {
  border-bottom: none;
}

.NewCustomSkillModal_sectionTitle__\\+VNYu {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 10px;
}

.NewCustomSkillModal_radioRow__cTBS6 {
  display: flex;
  gap: 18px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.NewCustomSkillModal_radioLabel__hAS6w {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
}

.NewCustomSkillModal_select__S5PgQ {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #111827;
  background: #fff;
}
.NewCustomSkillModal_select__S5PgQ:disabled {
  background: #f9fafb;
  color: #9ca3af;
}

.NewCustomSkillModal_hint__X4CSS {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  padding: 8px 10px;
  background: #f9fafb;
  border-radius: 6px;
}

.NewCustomSkillModal_suggestRow__pFJtf {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.NewCustomSkillModal_suggestBtn__A2YLg {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  background: #667eea;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}
.NewCustomSkillModal_suggestBtn__A2YLg:hover:not(:disabled) {
  background: #5568d3;
}
.NewCustomSkillModal_suggestBtn__A2YLg:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.NewCustomSkillModal_suggestHint__HG8tN {
  font-size: 12px;
  color: #6b7280;
  flex: 1 1;
  min-width: 200px;
}

.NewCustomSkillModal_errorBox__wq60\\+ {
  margin-top: 10px;
  padding: 8px 12px;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}

.NewCustomSkillModal_confidenceHigh__2Sp9Y,
.NewCustomSkillModal_confidenceMedium__eyBSX,
.NewCustomSkillModal_confidenceLow__aTCB0 {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}
.NewCustomSkillModal_confidenceHigh__2Sp9Y {
  background: #dcfce7;
  color: #166534;
}
.NewCustomSkillModal_confidenceMedium__eyBSX {
  background: #fef3c7;
  color: #92400e;
}
.NewCustomSkillModal_confidenceLow__aTCB0 {
  background: #fee2e2;
  color: #991b1b;
}

.NewCustomSkillModal_fieldRow__tpdHV {
  margin-bottom: 14px;
}

.NewCustomSkillModal_label__3\\+83y {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.NewCustomSkillModal_input__hlGjU,
.NewCustomSkillModal_textarea__Lwqfj {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #111827;
  background: #fff;
  font-family: inherit;
}
.NewCustomSkillModal_input__hlGjU:focus,
.NewCustomSkillModal_textarea__Lwqfj:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);
}
.NewCustomSkillModal_input__hlGjU:disabled,
.NewCustomSkillModal_textarea__Lwqfj:disabled {
  background: #f9fafb;
  color: #9ca3af;
}
.NewCustomSkillModal_textarea__Lwqfj {
  resize: vertical;
  min-height: 48px;
}

.NewCustomSkillModal_fieldHint__0Vb79 {
  margin-top: 4px;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.5;
}

.NewCustomSkillModal_fieldError__ASbKq {
  margin-top: 4px;
  font-size: 11px;
  color: #b91c1c;
}

/* ---------- chip input ---------- */

.NewCustomSkillModal_chipInput__ji0CR {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 8px;
  background: #fff;
}

.NewCustomSkillModal_chipRow__\\+qbl2 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
}

.NewCustomSkillModal_chip__KJaE8 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eef2ff;
  color: #3730a3;
  border-radius: 12px;
  padding: 3px 8px 3px 10px;
  font-size: 12px;
  line-height: 1.4;
  max-width: 100%;
}

.NewCustomSkillModal_chipText__OvzFH {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 420px;
}

.NewCustomSkillModal_chipRemove__g5KH7 {
  background: none;
  border: none;
  color: #4f46e5;
  cursor: pointer;
  padding: 0 0 0 2px;
  display: inline-flex;
  align-items: center;
}
.NewCustomSkillModal_chipRemove__g5KH7:hover {
  color: #b91c1c;
}

.NewCustomSkillModal_chipDraft__CIMHl {
  width: 100%;
  border: none;
  outline: none;
  font-size: 13px;
  padding: 4px 0;
  color: #111827;
  background: transparent;
}

.NewCustomSkillModal_chipHint__2-iM- {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 4px;
}

/* ---------- footer ---------- */

.NewCustomSkillModal_footer__6akDL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.NewCustomSkillModal_footerRight__x0yXx {
  display: flex;
  gap: 10px;
}

.NewCustomSkillModal_cancelBtn__kryQL {
  background: none;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}
.NewCustomSkillModal_cancelBtn__kryQL:hover:not(:disabled) {
  background: #f3f4f6;
}
.NewCustomSkillModal_cancelBtn__kryQL:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.NewCustomSkillModal_draftBtn__m7CeL {
  background: #fff;
  border: 1px solid #667eea;
  color: #4f46e5;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.NewCustomSkillModal_draftBtn__m7CeL:hover:not(:disabled) {
  background: #eef2ff;
}
.NewCustomSkillModal_draftBtn__m7CeL:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.NewCustomSkillModal_activateBtn__A71xx {
  background: #16a34a;
  border: 1px solid #16a34a;
  color: #fff;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.NewCustomSkillModal_activateBtn__A71xx:hover:not(:disabled) {
  background: #15803d;
}
.NewCustomSkillModal_activateBtn__A71xx:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/NewCustomSkillModal.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,mCAAQ,6DAAkC,EAAE;AAC5C,6CAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* NewCustomSkillModal.module.css */\n\n.spin { animation: spin 1s linear infinite; }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 680px;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.22);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n.closeBtn:hover:not(:disabled) {\n  background: #f3f4f6;\n  color: #111827;\n}\n.closeBtn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.intro {\n  margin: 0 0 16px 0;\n  font-size: 13px;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.section {\n  margin-bottom: 22px;\n  padding-bottom: 18px;\n  border-bottom: 1px dashed #e5e7eb;\n}\n.section:last-of-type {\n  border-bottom: none;\n}\n\n.sectionTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 10px;\n}\n\n.radioRow {\n  display: flex;\n  gap: 18px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.radioLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n}\n\n.select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #111827;\n  background: #fff;\n}\n.select:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n}\n\n.hint {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.5;\n  padding: 8px 10px;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n.suggestRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.suggestBtn {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 14px;\n  background: #667eea;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.suggestBtn:hover:not(:disabled) {\n  background: #5568d3;\n}\n.suggestBtn:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n.suggestHint {\n  font-size: 12px;\n  color: #6b7280;\n  flex: 1;\n  min-width: 200px;\n}\n\n.errorBox {\n  margin-top: 10px;\n  padding: 8px 12px;\n  background: #fee2e2;\n  color: #991b1b;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.5;\n  display: flex;\n  align-items: flex-start;\n}\n\n.confidenceHigh,\n.confidenceMedium,\n.confidenceLow {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.5;\n  display: flex;\n  align-items: flex-start;\n}\n.confidenceHigh {\n  background: #dcfce7;\n  color: #166534;\n}\n.confidenceMedium {\n  background: #fef3c7;\n  color: #92400e;\n}\n.confidenceLow {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.fieldRow {\n  margin-bottom: 14px;\n}\n\n.label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.input,\n.textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #111827;\n  background: #fff;\n  font-family: inherit;\n}\n.input:focus,\n.textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);\n}\n.input:disabled,\n.textarea:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n}\n.textarea {\n  resize: vertical;\n  min-height: 48px;\n}\n\n.fieldHint {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.fieldError {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #b91c1c;\n}\n\n/* ---------- chip input ---------- */\n\n.chipInput {\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 6px 8px;\n  background: #fff;\n}\n\n.chipRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #eef2ff;\n  color: #3730a3;\n  border-radius: 12px;\n  padding: 3px 8px 3px 10px;\n  font-size: 12px;\n  line-height: 1.4;\n  max-width: 100%;\n}\n\n.chipText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 420px;\n}\n\n.chipRemove {\n  background: none;\n  border: none;\n  color: #4f46e5;\n  cursor: pointer;\n  padding: 0 0 0 2px;\n  display: inline-flex;\n  align-items: center;\n}\n.chipRemove:hover {\n  color: #b91c1c;\n}\n\n.chipDraft {\n  width: 100%;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  padding: 4px 0;\n  color: #111827;\n  background: transparent;\n}\n\n.chipHint {\n  font-size: 11px;\n  color: #9ca3af;\n  margin-top: 4px;\n}\n\n/* ---------- footer ---------- */\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.footerRight {\n  display: flex;\n  gap: 10px;\n}\n\n.cancelBtn {\n  background: none;\n  border: 1px solid #d1d5db;\n  color: #374151;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n.cancelBtn:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n.cancelBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.draftBtn {\n  background: #fff;\n  border: 1px solid #667eea;\n  color: #4f46e5;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.draftBtn:hover:not(:disabled) {\n  background: #eef2ff;\n}\n.draftBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.activateBtn {\n  background: #16a34a;\n  border: 1px solid #16a34a;\n  color: #fff;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.activateBtn:hover:not(:disabled) {\n  background: #15803d;\n}\n.activateBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spin": `NewCustomSkillModal_spin__Iv2Cb`,
	"overlay": `NewCustomSkillModal_overlay__iQRhZ`,
	"modal": `NewCustomSkillModal_modal__R4h8S`,
	"header": `NewCustomSkillModal_header__lru86`,
	"title": `NewCustomSkillModal_title__66TRW`,
	"closeBtn": `NewCustomSkillModal_closeBtn__3Kevh`,
	"body": `NewCustomSkillModal_body__h-GZH`,
	"intro": `NewCustomSkillModal_intro__ekX0W`,
	"section": `NewCustomSkillModal_section__6IU6f`,
	"sectionTitle": `NewCustomSkillModal_sectionTitle__+VNYu`,
	"radioRow": `NewCustomSkillModal_radioRow__cTBS6`,
	"radioLabel": `NewCustomSkillModal_radioLabel__hAS6w`,
	"select": `NewCustomSkillModal_select__S5PgQ`,
	"hint": `NewCustomSkillModal_hint__X4CSS`,
	"suggestRow": `NewCustomSkillModal_suggestRow__pFJtf`,
	"suggestBtn": `NewCustomSkillModal_suggestBtn__A2YLg`,
	"suggestHint": `NewCustomSkillModal_suggestHint__HG8tN`,
	"errorBox": `NewCustomSkillModal_errorBox__wq60+`,
	"confidenceHigh": `NewCustomSkillModal_confidenceHigh__2Sp9Y`,
	"confidenceMedium": `NewCustomSkillModal_confidenceMedium__eyBSX`,
	"confidenceLow": `NewCustomSkillModal_confidenceLow__aTCB0`,
	"fieldRow": `NewCustomSkillModal_fieldRow__tpdHV`,
	"label": `NewCustomSkillModal_label__3+83y`,
	"input": `NewCustomSkillModal_input__hlGjU`,
	"textarea": `NewCustomSkillModal_textarea__Lwqfj`,
	"fieldHint": `NewCustomSkillModal_fieldHint__0Vb79`,
	"fieldError": `NewCustomSkillModal_fieldError__ASbKq`,
	"chipInput": `NewCustomSkillModal_chipInput__ji0CR`,
	"chipRow": `NewCustomSkillModal_chipRow__+qbl2`,
	"chip": `NewCustomSkillModal_chip__KJaE8`,
	"chipText": `NewCustomSkillModal_chipText__OvzFH`,
	"chipRemove": `NewCustomSkillModal_chipRemove__g5KH7`,
	"chipDraft": `NewCustomSkillModal_chipDraft__CIMHl`,
	"chipHint": `NewCustomSkillModal_chipHint__2-iM-`,
	"footer": `NewCustomSkillModal_footer__6akDL`,
	"footerRight": `NewCustomSkillModal_footerRight__x0yXx`,
	"cancelBtn": `NewCustomSkillModal_cancelBtn__kryQL`,
	"draftBtn": `NewCustomSkillModal_draftBtn__m7CeL`,
	"activateBtn": `NewCustomSkillModal_activateBtn__A71xx`
};
export default ___CSS_LOADER_EXPORT___;
